// @flow

import React, { Component } from 'react';
import {Icon} from 'react-fa';


type T_ButtonUpProps = {
  fun    : () => void,
  enabled: boolean
};



export default class ButtonUp extends Component<T_ButtonUpProps> {
  click = (ev: SyntheticEvent<*>) => {
    if (this.props.enabled)
      this.props.fun();
  }
  
  
  
  render() {
    const style = ! this.props.enabled ? {style: {color: 'gray'}} : {};
    
    return (
      <a onClick={this.click} className='dir_back' {...style}>
        <Icon name='arrow-circle-up' size='2x' />
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ButtonUp.jsx